// extracted by mini-css-extract-plugin
export default {"root":"status-tag_root__gaouK","label":"status-tag_label__V8fPh","dot":"status-tag_dot__utBYU","section":"status-tag_section__fjOdJ"};